import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const VISITOR_KEY = "cph_visitor_id";

function isBot() {
  const ua = navigator.userAgent || "";
  // react-snap prerenders with a "ReactSnap" user agent — never track it.
  return /ReactSnap|Prerender|HeadlessChrome|Googlebot|bingbot/i.test(ua);
}

function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        (crypto?.randomUUID && crypto.randomUUID()) ||
        `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

// Classify where this visit came from. document.referrer only reflects the
// referrer of the initial document load, so in-session SPA navigations report
// the same host → we tag those "Internal" and let the backend drop them.
function getReferrerSource() {
  try {
    const ref = document.referrer;
    if (!ref) return "Direct";
    const url = new URL(ref);
    if (url.hostname === window.location.hostname) return "Internal";
    return url.hostname.replace(/^www\./, "").slice(0, 200);
  } catch {
    return "Direct";
  }
}

export function trackPageview(path) {
  if (isBot()) return;
  const visitor_id = getVisitorId();
  if (!visitor_id) return;
  // Close out the previous page's active time before starting the new one.
  flushDuration();
  durPath = path;
  durAccumMs = 0;
  durResume = document.visibilityState === "visible" ? Date.now() : null;
  axios
    .post(`${API}/api/analytics/track`, {
      visitor_id,
      path,
      referrer: getReferrerSource(),
    })
    .catch(() => {});
}

// ---------------------------------------------------------------------------
// Time on page — measures foreground (visible) time per path and reports it
// when the visitor leaves the page (SPA route change, tab hide or unload).
// ---------------------------------------------------------------------------
let durPath = null;
let durAccumMs = 0; // active time banked so far on the current path
let durResume = null; // timestamp the current visible segment started (or null)

function pauseSegment() {
  if (durResume != null) {
    durAccumMs += Date.now() - durResume;
    durResume = null;
  }
}

function flushDuration() {
  pauseSegment();
  if (!durPath) return;
  const seconds = Math.min(Math.round(durAccumMs / 1000), 3600);
  durAccumMs = 0;
  if (seconds < 2) return; // ignore instant bounces / noise
  const visitor_id = getVisitorId();
  if (!visitor_id) return;
  const url = `${API}/api/analytics/duration`;
  const body = JSON.stringify({ visitor_id, path: durPath, seconds });
  // sendBeacon survives unload; fall back to a keepalive fetch/axios otherwise.
  if (navigator.sendBeacon) {
    navigator.sendBeacon(url, new Blob([body], { type: "application/json" }));
  } else {
    axios.post(url, JSON.parse(body)).catch(() => {});
  }
}

if (typeof document !== "undefined" && !isBot()) {
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      flushDuration(); // banks + sends whatever active time we have
    } else if (durPath) {
      durResume = Date.now(); // resume counting for the same page
    }
  });
  // Full-page unloads (tab close, refresh, external navigation).
  window.addEventListener("pagehide", flushDuration);
}
